<template>
  <div class="navbar">
    <hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />
    <div class="right-navbar">
      <div style="display: flex;">
        <patterns id="breadcrumb-container" class="breadcrumb-container" :tips="tips" :version-title="versionTitle" :default-shop="defaultShop" />
        <breadcrumb v-if="defaultShop && defaultShop.shopId" id="breadcrumb-container" class="breadcrumb-container" :shop-data="shopData" :default-shop="defaultShop" @switch="shop" />
        <div
          style="position: relative;top: 8px;"
        >
<!--          <div id="nickname" style="float: left;line-height: 38px;margin-right: 15px;" /> -->
          <div id="sj" style="float: left;line-height: 38px;" />
          <div id="huhu" style="float: left;line-height: 38px;margin-right: 15px;width: 55px;" />
          <div id="sms" style="float: left;line-height: 38px;margin-right: 15px;" />
        </div>
      </div>
      <!-- <span>9843389759</span> -->
      <div class="center-container">
        <div @click="optionAction(item)" v-for="item in centerList" :key="item">{{ item }}</div>
      </div>
      <div class="right-menu">
        <template v-if="device !== 'mobile'">
          <search id="header-search" class="right-menu-item" />
          <!-- <error-log class="errLog-container right-menu-item hover-effect" /> -->

          <!-- <span>834739</span> -->
          <screenfull id="screenfull" class="right-menu-item hover-effect" />
          <el-tooltip :content="$t('navbar.size')" effect="dark" placement="bottom">
            <!-- <div>9456805986</div> -->
            <!-- <size-select id="size-select" class="right-menu-item hover-effect" /> -->
          </el-tooltip>
          <!-- <lang-select class="right-menu-item hover-effect" /> -->
        </template>

        <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
          <div v-loading="imgLoading" class="avatar-wrapper">
            <img v-if="imgSrc !== ''" :src="imgSrc" class="user-avatar">
            <svg-icon v-else icon-class="login-dou-dian" style="color: #fff; font-size: 40px" />
            <i class="el-icon-caret-bottom" />
          </div>
          <el-dropdown-menu slot="dropdown">
            <!-- <router-link to="/profile/index1">
              <el-dropdown-item>
                个人中心
              </el-dropdown-item>
            </router-link> -->
            <router-link to="/">
              <el-dropdown-item>
                <!-- {{ $t('navbar.dashboard') }} -->
                首页
              </el-dropdown-item>
            </router-link>
            <!-- <a
              target="_blank"
              href="https://github.com/PanJiaChen/vue-element-admin/"
            >
              <el-dropdown-item>
                {{ $t('navbar.github') }}
              </el-dropdown-item>
            </a> -->
            <!-- <a
              target="_blank"
              href="https://panjiachen.github.io/vue-element-admin-site/#/"
            >
              <el-dropdown-item>Docs</el-dropdown-item>
            </a> -->
            <!-- 退出登陆 -->
            <el-dropdown-item divided @click.native="logout">
              <span style="display: block">
                <!-- {{ $t('navbar.logOut') }} -->
                退出登陆
              </span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div id="smsapp" />
    <el-dialog title="关联码" width="400px" :visible.sync="copyDialogVisible" :close-on-click-modal="false">
      <div class="code-content">
        <div>
          <el-image :src="shopMessage.mall_logo" :style="{ width: '100%' }">
            <div slot="error" class="image-slot">
              <svg-icon icon-class="login-dou-dian" style="font-size: 80px;" class="card-panel-icon" />
            </div>
          </el-image>
        </div>
        <p>
          <span>店铺名称：</span>
          <span>{{ shopMessage.mall_name || '-' }}</span>
        </p>
        <p>
          <span>店铺ID：</span>
          <span>{{ shopMessage.mall_id || '-' }}</span>
        </p>
        <p>
          <span>店铺编码：</span>
          <span>{{ shopMessage.token || '-' }}</span>
        </p>
        <p class="copy-btn">
          <span @click="copyCode(shopMessage.token || '')"><i class="el-icon-copy-document" /> 复制店铺码</span>
          <span @click="copyCode(`店铺名称：${shopMessage.mall_name || ''}\n关联码：${shopMessage.token || ''}`)"><i class="el-icon-copy-document" /> 复制店铺码和名称</span>
        </p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// const path = require('path')
// const { exec } = require('child_process')
import Vue from 'vue';
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Patterns from '@/components/Patterns'
import Hamburger from '@/components/Hamburger'
// import ErrorLog from '@/components/ErrorLog'
import Screenfull from '@/components/Screenfull'
import Search from '@/components/HeaderSearch'
import { shop } from '@/api/address'
import { getMcToken } from '@/api/home.js'
// const { captureScreenshot } = require('../../../../screenshot.js');
// import { io } from "socket.io-client"
// import html2canvas from 'html2canvas';
export default {
  components: {
    Breadcrumb,
    Hamburger,
    // ErrorLog,
    Screenfull,
    Search,
    Patterns
  },
  data() {

    return {
      imgSrc: null,
      shopData: [],
      defaultShop: { shopId: '', shopName: '' },
      versionTitle: '基础版',
      tips: '',
      imgLoading: false,
      //centerList: ['打单发货', '添加店铺', '关联码', '单号回收', '直播标签'],
      centerList: ['打单发货', '添加店铺', '关联码', '单号回收'],
      copyDialogVisible: false,
      shopMessage: {
        mall_logo: '',
        mall_name: '',
        mall_id: '',
        token: ''
      }
    }
  },
  computed: {
    ...mapGetters(['sidebar', 'avatar', 'device']),
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  created() {
    this.shop()
  },
  methods: {
    optionAction(item) {
      if (item === '关联码') {
        this.copyDialogVisible = true
      }
      if(item ==='打单发货') {
          this.$router.push('/deliver/pending')
      }
      if(item ==='单号回收') {
        this.$router.push('/deliver/record')
      }
      if(item ==='添加店铺') {
        this.$router.push('/shop/list')
      }
      if(item ==='直播标签') {
        this.$message.success('内测功能，即将上线')
        //this.$router.push('/setting/template')
      }
    },
    copyCode(text) {
      this.copyText(text)
      this.$message.success('复制成功')
    },
    copyText(text) {
      const input = document.createElement('textarea')
      input.value = text
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
    },
    // 获取多店铺
    async shop() {
      this.imgLoading = true
      const { data } = await shop().catch(() => {
        this.imgLoading = false
        return
      })
      try {
        if (data.code === 0) {
          const old_id = localStorage.getItem('shopId')
          const userInfo = JSON.parse(localStorage.getItem('userInfo'));
          this.imgSrc = userInfo?.mall_logo?? null,
          console.log(data)
          this.shopData = data.data.list
          this.tips = data.data.tips
          this.versionTitle = data.data.version_title
          for (var item of data.data.list) {
            if (item.def === 1 && old_id !==item.id) {
              this.defaultShop.shopName = item.mall_name
              this.defaultShop.shopId = item.id
              localStorage.setItem('shopId', item.id)
              localStorage.setItem('shopName', item.mall_name)
              localStorage.setItem('mall_id', item.mall_id)
              localStorage.setItem('mall_token', item.token)
              this.shopMessage = { ...item }
            }
          }
          const new_id = localStorage.getItem('shopId')
          localStorage.setItem('shopData', JSON.stringify(data.data.list))
          const setEvent = new Event('changeShopId')
          setEvent.key = 'shopId'
          setEvent.value = new_id
          window.dispatchEvent(setEvent)
          this.initActivity()
          this.imgLoading = false
          if (old_id && old_id !== new_id) {
            window.location.reload()
          }
          // window.location.reload()
        } else {
          this.imgLoading = false
        }
      } catch (error) {
          // 错误处理
          window.location.reload()
        }
    },
    async initActivity() {
      const { data } = await getMcToken({
        m_id: localStorage.getItem('shopId')
      })
      if (data.code === 0) {
        console.log('McToken',data.data)
        localStorage.setItem('bixi', JSON.stringify(data.data))
        ecopen.start(data.data)
        const hudata = data.data
        const cudata = data.data
        const smsdata = data.data
        const smstdata = data.data
        hudata.componentId = 317
        document.getElementById('huhu').innerHTML = ''
        ecopen.bixi(document.getElementById('huhu'), hudata)
        smsdata.componentId = 371
        document.getElementById('sms').innerHTML = ''
        ecopen.bixi(document.getElementById('sms'), smsdata)
        cudata.componentId = 330
        ecopen.bixi(document.body, cudata)
        smstdata.componentId = 381
        document.getElementById('sj').innerHTML = ''
        ecopen.bixi(document.getElementById('sj'), smstdata)
      }
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    }
  }
}
</script>

<style lang="scss" scoped>
#huhu .op_component_message_count.svelte-k4zunn {
    top: -5px !important;

  }
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: var(--main-color);
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  color:#fff;
  .right-navbar{
    display: flex;
    justify-content: space-between;
  }

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;
    color: #fff;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    // float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }
  .center-container{
    display: flex;
    align-items: center;
    height:50px;
    div{
      margin-right: 14px;
      cursor: pointer;
      min-width: 40px;
      font-size: 14px;
    }
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      height: 50px;
      display: inline-block;
      padding: 0 8px;
      // height: 100%;
      font-size: 14px;
      color: #fff;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 14px;
          font-size: 12px;
        }
      }
    }
  }
}
.code-content{
    >div:nth-child(1){
      width: 100px;
      height: 100px;
      margin:  0 auto;
      >img{
        width: 100%;
      }
    }
    >p{
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      color: #333333;
      line-height: 19px;
      margin-bottom: 24px;
      >span:nth-child(1){
        color: #999999;
      }
      >span:nth-child(2){
      font-size: 14px;
      }
    }
    >p:last-child{
      margin-bottom: 0px;
    }
  }
  .copy-btn{
    display: flex;
    justify-content: flex-end !important;
    >span{
      color: #ff9900;
      cursor: pointer;
    }
    >span:nth-child(1){
      color: #ff9900 !important;
      margin-right: 20px;
    }
  }
</style>
<style lang="scss">
.op_component_base_container.svelte-k4zunn{
    color: #fff !important;
  }
</style>
